import { render, staticRenderFns } from "./ModuleSettingsTableComponent.vue?vue&type=template&id=7d284864&scoped=true"
import script from "./ModuleSettingsTableComponent.vue?vue&type=script&lang=js"
export * from "./ModuleSettingsTableComponent.vue?vue&type=script&lang=js"
import style0 from "./ModuleSettingsTableComponent.vue?vue&type=style&index=0&id=7d284864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d284864",
  null
  
)

export default component.exports